import { Reveal } from "@/components/Reveal";

const CHAPTERS = [
  {
    num: "01",
    title: "DISCIPLINE",
    body: "Talent is everywhere. Discipline is not. We teach young people that showing up — early, every time, no excuses — is the first championship they'll ever win.",
  },
  {
    num: "02",
    title: "ACCOUNTABILITY",
    body: "Every young person answers to their goals, their team, and themselves. Our mentors help youth own their choices and track their progress.",
  },
  {
    num: "03",
    title: "CONFIDENCE",
    body: "Confidence is built rep by rep — in the classroom, in training, in leadership. We celebrate progress loudly and often.",
  },
  {
    num: "04",
    title: "OPPORTUNITY",
    body: "College visits, career workshops, community partnerships — we open doors so every young person can see a future worth grinding for.",
  },
];

export const Manifesto = () => (
  <section className="py-20 sm:py-28 lg:py-36 px-4 sm:px-8 lg:px-16 bg-grid" data-testid="manifesto-section">
    <Reveal>
      <div className="font-mono text-xs sm:text-sm tracking-[0.3em] uppercase text-[#FFB800] mb-4">The Manifesto</div>
      <h2 className="font-display font-black uppercase tracking-tight leading-none text-3xl sm:text-4xl lg:text-6xl text-[#F4F4F6] max-w-3xl">
        Four chapters. <span className="text-outline">One standard.</span>
      </h2>
    </Reveal>

    <div className="mt-16 grid grid-cols-1 md:grid-cols-12 gap-8 items-start">
      {CHAPTERS.map((c, i) => (
        <Reveal
          key={c.num}
          delay={i * 0.1}
          className={`border border-[#242436] hover:border-[#8B5CF6]/50 transition-colors duration-300 bg-[#111118] p-8 shadow-[0_4px_30px_rgba(0,0,0,0.5)] ${
            i % 2 === 0 ? "md:col-span-5" : "md:col-span-7"
          } ${i % 2 === 1 ? "md:mt-12" : ""}`}
        >
          <div className="font-mono text-xs sm:text-sm tracking-[0.3em] uppercase text-[#FFB800]" data-testid={`manifesto-num-${c.num}`}>
            CHAPTER {c.num}
          </div>
          <h3 className="font-display font-black uppercase tracking-wide text-2xl sm:text-3xl text-[#F4F4F6] mt-4">{c.title}</h3>
          <p className="text-sm sm:text-base leading-relaxed text-[#A1A1B3] mt-4">{c.body}</p>
        </Reveal>
      ))}
    </div>
  </section>
);
